import { schema } from "normalizr"

const authorSchema = new schema.Entity("authors")

export default authorSchema
